import * as Q from "react";
import Gr, { forwardRef as ur, useContext as Ft, createContext as Mt, Children as jt } from "react";
import { Spin as Lt } from "@illa-design/spin";
import { css as S } from "@emotion/react";
import { globalColor as Jr, illaPrefix as Kr, applyBoxStyle as Hr, deleteCssProps as Zr } from "@illa-design/theme";
var ar = { exports: {} }, ge = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function Yt() {
  if (Nr)
    return ge;
  Nr = 1;
  var e = Gr, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(l, p, m) {
    var d, y = {}, R = null, C = null;
    m !== void 0 && (R = "" + m), p.key !== void 0 && (R = "" + p.key), p.ref !== void 0 && (C = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: R, ref: C, props: y, _owner: o.current };
  }
  return ge.Fragment = t, ge.jsx = u, ge.jsxs = u, ge;
}
var Ee = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Vt() {
  return Ar || (Ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Gr, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), N = Symbol.iterator, g = "@@iterator";
    function F(n) {
      if (n === null || typeof n != "object")
        return null;
      var s = N && n[N] || n[g];
      return typeof s == "function" ? s : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(n) {
      {
        for (var s = arguments.length, f = new Array(s > 1 ? s - 1 : 0), v = 1; v < s; v++)
          f[v - 1] = arguments[v];
        k("error", n, f);
      }
    }
    function k(n, s, f) {
      {
        var v = E.ReactDebugCurrentFrame, w = v.getStackAddendum();
        w !== "" && (s += "%s", f = f.concat([w]));
        var I = f.map(function(_) {
          return String(_);
        });
        I.unshift("Warning: " + s), Function.prototype.apply.call(console[n], console, I);
      }
    }
    var D = !1, c = !1, Y = !1, A = !1, Be = !1, Re;
    Re = Symbol.for("react.module.reference");
    function Ge(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === a || n === i || Be || n === o || n === m || n === d || A || n === C || D || c || Y || typeof n == "object" && n !== null && (n.$$typeof === R || n.$$typeof === y || n.$$typeof === u || n.$$typeof === l || n.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === Re || n.getModuleId !== void 0));
    }
    function Je(n, s, f) {
      var v = n.displayName;
      if (v)
        return v;
      var w = s.displayName || s.name || "";
      return w !== "" ? f + "(" + w + ")" : f;
    }
    function we(n) {
      return n.displayName || "Context";
    }
    function G(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case a:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case l:
            var s = n;
            return we(s) + ".Consumer";
          case u:
            var f = n;
            return we(f._context) + ".Provider";
          case p:
            return Je(n, n.render, "ForwardRef");
          case y:
            var v = n.displayName || null;
            return v !== null ? v : G(n.type) || "Memo";
          case R: {
            var w = n, I = w._payload, _ = w._init;
            try {
              return G(_(I));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, re = 0, Te, Oe, le, Pe, de, $e, Ne;
    function Ae() {
    }
    Ae.__reactDisabledLog = !0;
    function Ke() {
      {
        if (re === 0) {
          Te = console.log, Oe = console.info, le = console.warn, Pe = console.error, de = console.group, $e = console.groupCollapsed, Ne = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: Ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        re++;
      }
    }
    function He() {
      {
        if (re--, re === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, n, {
              value: Te
            }),
            info: Z({}, n, {
              value: Oe
            }),
            warn: Z({}, n, {
              value: le
            }),
            error: Z({}, n, {
              value: Pe
            }),
            group: Z({}, n, {
              value: de
            }),
            groupCollapsed: Z({}, n, {
              value: $e
            }),
            groupEnd: Z({}, n, {
              value: Ne
            })
          });
        }
        re < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = E.ReactCurrentDispatcher, he;
    function ne(n, s, f) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (w) {
            var v = w.stack.trim().match(/\n( *(at )?)/);
            he = v && v[1] || "";
          }
        return `
` + he + n;
      }
    }
    var me = !1, ae;
    {
      var Ze = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new Ze();
    }
    function h(n, s) {
      if (!n || me)
        return "";
      {
        var f = ae.get(n);
        if (f !== void 0)
          return f;
      }
      var v;
      me = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var I;
      I = pe.current, pe.current = null, Ke();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (X) {
              v = X;
            }
            Reflect.construct(n, [], _);
          } else {
            try {
              _.call();
            } catch (X) {
              v = X;
            }
            n.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (X) {
            v = X;
          }
          n();
        }
      } catch (X) {
        if (X && v && typeof X.stack == "string") {
          for (var x = X.stack.split(`
`), z = v.stack.split(`
`), M = x.length - 1, j = z.length - 1; M >= 1 && j >= 0 && x[M] !== z[j]; )
            j--;
          for (; M >= 1 && j >= 0; M--, j--)
            if (x[M] !== z[j]) {
              if (M !== 1 || j !== 1)
                do
                  if (M--, j--, j < 0 || x[M] !== z[j]) {
                    var B = `
` + x[M].replace(" at new ", " at ");
                    return n.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", n.displayName)), typeof n == "function" && ae.set(n, B), B;
                  }
                while (M >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        me = !1, pe.current = I, He(), Error.prepareStackTrace = w;
      }
      var se = n ? n.displayName || n.name : "", $r = se ? ne(se) : "";
      return typeof n == "function" && ae.set(n, $r), $r;
    }
    function ve(n, s, f) {
      return h(n, !1);
    }
    function oe(n) {
      var s = n.prototype;
      return !!(s && s.isReactComponent);
    }
    function te(n, s, f) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return h(n, oe(n));
      if (typeof n == "string")
        return ne(n);
      switch (n) {
        case m:
          return ne("Suspense");
        case d:
          return ne("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case p:
            return ve(n.render);
          case y:
            return te(n.type, s, f);
          case R: {
            var v = n, w = v._payload, I = v._init;
            try {
              return te(I(w), s, f);
            } catch {
            }
          }
        }
      return "";
    }
    var ke = Object.prototype.hasOwnProperty, gr = {}, Er = E.ReactDebugCurrentFrame;
    function Ie(n) {
      if (n) {
        var s = n._owner, f = te(n.type, n._source, s ? s.type : null);
        Er.setExtraStackFrame(f);
      } else
        Er.setExtraStackFrame(null);
    }
    function vt(n, s, f, v, w) {
      {
        var I = Function.call.bind(ke);
        for (var _ in n)
          if (I(n, _)) {
            var x = void 0;
            try {
              if (typeof n[_] != "function") {
                var z = Error((v || "React class") + ": " + f + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw z.name = "Invariant Violation", z;
              }
              x = n[_](s, _, v, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              x = M;
            }
            x && !(x instanceof Error) && (Ie(w), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", f, _, typeof x), Ie(null)), x instanceof Error && !(x.message in gr) && (gr[x.message] = !0, Ie(w), b("Failed %s type: %s", f, x.message), Ie(null));
          }
      }
    }
    var yt = Array.isArray;
    function Xe(n) {
      return yt(n);
    }
    function gt(n) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, f = s && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return f;
      }
    }
    function Et(n) {
      try {
        return br(n), !1;
      } catch {
        return !0;
      }
    }
    function br(n) {
      return "" + n;
    }
    function xr(n) {
      if (Et(n))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", gt(n)), br(n);
    }
    var ye = E.ReactCurrentOwner, bt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _r, Sr, Qe;
    Qe = {};
    function xt(n) {
      if (ke.call(n, "ref")) {
        var s = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function _t(n) {
      if (ke.call(n, "key")) {
        var s = Object.getOwnPropertyDescriptor(n, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function St(n, s) {
      if (typeof n.ref == "string" && ye.current && s && ye.current.stateNode !== s) {
        var f = G(ye.current.type);
        Qe[f] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(ye.current.type), n.ref), Qe[f] = !0);
      }
    }
    function Ct(n, s) {
      {
        var f = function() {
          _r || (_r = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Rt(n, s) {
      {
        var f = function() {
          Sr || (Sr = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var wt = function(n, s, f, v, w, I, _) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: n,
        key: s,
        ref: f,
        props: _,
        // Record the component responsible for creating this element.
        _owner: I
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Tt(n, s, f, v, w) {
      {
        var I, _ = {}, x = null, z = null;
        f !== void 0 && (xr(f), x = "" + f), _t(s) && (xr(s.key), x = "" + s.key), xt(s) && (z = s.ref, St(s, w));
        for (I in s)
          ke.call(s, I) && !bt.hasOwnProperty(I) && (_[I] = s[I]);
        if (n && n.defaultProps) {
          var M = n.defaultProps;
          for (I in M)
            _[I] === void 0 && (_[I] = M[I]);
        }
        if (x || z) {
          var j = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          x && Ct(_, j), z && Rt(_, j);
        }
        return wt(n, x, z, w, v, ye.current, _);
      }
    }
    var er = E.ReactCurrentOwner, Cr = E.ReactDebugCurrentFrame;
    function ie(n) {
      if (n) {
        var s = n._owner, f = te(n.type, n._source, s ? s.type : null);
        Cr.setExtraStackFrame(f);
      } else
        Cr.setExtraStackFrame(null);
    }
    var rr;
    rr = !1;
    function tr(n) {
      return typeof n == "object" && n !== null && n.$$typeof === r;
    }
    function Rr() {
      {
        if (er.current) {
          var n = G(er.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function Ot(n) {
      {
        if (n !== void 0) {
          var s = n.fileName.replace(/^.*[\\\/]/, ""), f = n.lineNumber;
          return `

Check your code at ` + s + ":" + f + ".";
        }
        return "";
      }
    }
    var wr = {};
    function Pt(n) {
      {
        var s = Rr();
        if (!s) {
          var f = typeof n == "string" ? n : n.displayName || n.name;
          f && (s = `

Check the top-level render call using <` + f + ">.");
        }
        return s;
      }
    }
    function Tr(n, s) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var f = Pt(s);
        if (wr[f])
          return;
        wr[f] = !0;
        var v = "";
        n && n._owner && n._owner !== er.current && (v = " It was passed a child from " + G(n._owner.type) + "."), ie(n), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, v), ie(null);
      }
    }
    function Or(n, s) {
      {
        if (typeof n != "object")
          return;
        if (Xe(n))
          for (var f = 0; f < n.length; f++) {
            var v = n[f];
            tr(v) && Tr(v, s);
          }
        else if (tr(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var w = F(n);
          if (typeof w == "function" && w !== n.entries)
            for (var I = w.call(n), _; !(_ = I.next()).done; )
              tr(_.value) && Tr(_.value, s);
        }
      }
    }
    function $t(n) {
      {
        var s = n.type;
        if (s == null || typeof s == "string")
          return;
        var f;
        if (typeof s == "function")
          f = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          f = s.propTypes;
        else
          return;
        if (f) {
          var v = G(s);
          vt(f, n.props, "prop", v, n);
        } else if (s.PropTypes !== void 0 && !rr) {
          rr = !0;
          var w = G(s);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Nt(n) {
      {
        for (var s = Object.keys(n.props), f = 0; f < s.length; f++) {
          var v = s[f];
          if (v !== "children" && v !== "key") {
            ie(n), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), ie(null);
            break;
          }
        }
        n.ref !== null && (ie(n), b("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      }
    }
    function Pr(n, s, f, v, w, I) {
      {
        var _ = Ge(n);
        if (!_) {
          var x = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var z = Ot(w);
          z ? x += z : x += Rr();
          var M;
          n === null ? M = "null" : Xe(n) ? M = "array" : n !== void 0 && n.$$typeof === r ? (M = "<" + (G(n.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : M = typeof n, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, x);
        }
        var j = Tt(n, s, f, w, I);
        if (j == null)
          return j;
        if (_) {
          var B = s.children;
          if (B !== void 0)
            if (v)
              if (Xe(B)) {
                for (var se = 0; se < B.length; se++)
                  Or(B[se], n);
                Object.freeze && Object.freeze(B);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Or(B, n);
        }
        return n === a ? Nt(j) : $t(j), j;
      }
    }
    function At(n, s, f) {
      return Pr(n, s, f, !0);
    }
    function kt(n, s, f) {
      return Pr(n, s, f, !1);
    }
    var It = kt, Dt = At;
    Ee.Fragment = a, Ee.jsx = It, Ee.jsxs = Dt;
  }()), Ee;
}
process.env.NODE_ENV === "production" ? ar.exports = Yt() : ar.exports = Vt();
var Le = ar.exports;
function Wt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function zt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Ut = /* @__PURE__ */ function() {
  function e(t) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(zt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var u = Wt(o);
      try {
        u.insertRule(a, u.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), W = "-ms-", Ye = "-moz-", T = "-webkit-", lr = "comm", dr = "rule", pr = "decl", qt = "@import", Xr = "@keyframes", Bt = "@layer", Gt = Math.abs, We = String.fromCharCode, Jt = Object.assign;
function Kt(e, r) {
  return V(e, 0) ^ 45 ? (((r << 2 ^ V(e, 0)) << 2 ^ V(e, 1)) << 2 ^ V(e, 2)) << 2 ^ V(e, 3) : 0;
}
function Qr(e) {
  return e.trim();
}
function Ht(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function O(e, r, t) {
  return e.replace(r, t);
}
function or(e, r) {
  return e.indexOf(r);
}
function V(e, r) {
  return e.charCodeAt(r) | 0;
}
function xe(e, r, t) {
  return e.slice(r, t);
}
function K(e) {
  return e.length;
}
function hr(e) {
  return e.length;
}
function De(e, r) {
  return r.push(e), e;
}
function Zt(e, r) {
  return e.map(r).join("");
}
var ze = 1, fe = 1, et = 0, U = 0, L = 0, ue = "";
function Ue(e, r, t, a, o, i, u) {
  return { value: e, root: r, parent: t, type: a, props: o, children: i, line: ze, column: fe, length: u, return: "" };
}
function be(e, r) {
  return Jt(Ue("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Xt() {
  return L;
}
function Qt() {
  return L = U > 0 ? V(ue, --U) : 0, fe--, L === 10 && (fe = 1, ze--), L;
}
function q() {
  return L = U < et ? V(ue, U++) : 0, fe++, L === 10 && (fe = 1, ze++), L;
}
function H() {
  return V(ue, U);
}
function Fe() {
  return U;
}
function Ce(e, r) {
  return xe(ue, e, r);
}
function _e(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function rt(e) {
  return ze = fe = 1, et = K(ue = e), U = 0, [];
}
function tt(e) {
  return ue = "", e;
}
function Me(e) {
  return Qr(Ce(U - 1, ir(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function en(e) {
  for (; (L = H()) && L < 33; )
    q();
  return _e(e) > 2 || _e(L) > 3 ? "" : " ";
}
function rn(e, r) {
  for (; --r && q() && !(L < 48 || L > 102 || L > 57 && L < 65 || L > 70 && L < 97); )
    ;
  return Ce(e, Fe() + (r < 6 && H() == 32 && q() == 32));
}
function ir(e) {
  for (; q(); )
    switch (L) {
      case e:
        return U;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ir(L);
        break;
      case 40:
        e === 41 && ir(e);
        break;
      case 92:
        q();
        break;
    }
  return U;
}
function tn(e, r) {
  for (; q() && e + L !== 47 + 10; )
    if (e + L === 42 + 42 && H() === 47)
      break;
  return "/*" + Ce(r, U - 1) + "*" + We(e === 47 ? e : q());
}
function nn(e) {
  for (; !_e(H()); )
    q();
  return Ce(e, U);
}
function an(e) {
  return tt(je("", null, null, null, [""], e = rt(e), 0, [0], e));
}
function je(e, r, t, a, o, i, u, l, p) {
  for (var m = 0, d = 0, y = u, R = 0, C = 0, N = 0, g = 1, F = 1, E = 1, b = 0, k = "", D = o, c = i, Y = a, A = k; F; )
    switch (N = b, b = q()) {
      case 40:
        if (N != 108 && V(A, y - 1) == 58) {
          or(A += O(Me(b), "&", "&\f"), "&\f") != -1 && (E = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += Me(b);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += en(N);
        break;
      case 92:
        A += rn(Fe() - 1, 7);
        continue;
      case 47:
        switch (H()) {
          case 42:
          case 47:
            De(on(tn(q(), Fe()), r, t), p);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * g:
        l[m++] = K(A) * E;
      case 125 * g:
      case 59:
      case 0:
        switch (b) {
          case 0:
          case 125:
            F = 0;
          case 59 + d:
            E == -1 && (A = O(A, /\f/g, "")), C > 0 && K(A) - y && De(C > 32 ? Ir(A + ";", a, t, y - 1) : Ir(O(A, " ", "") + ";", a, t, y - 2), p);
            break;
          case 59:
            A += ";";
          default:
            if (De(Y = kr(A, r, t, m, d, o, l, k, D = [], c = [], y), i), b === 123)
              if (d === 0)
                je(A, r, Y, Y, D, i, y, l, c);
              else
                switch (R === 99 && V(A, 3) === 110 ? 100 : R) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    je(e, Y, Y, a && De(kr(e, Y, Y, 0, 0, o, l, k, o, D = [], y), c), o, c, y, l, a ? D : c);
                    break;
                  default:
                    je(A, Y, Y, Y, [""], c, 0, l, c);
                }
        }
        m = d = C = 0, g = E = 1, k = A = "", y = u;
        break;
      case 58:
        y = 1 + K(A), C = N;
      default:
        if (g < 1) {
          if (b == 123)
            --g;
          else if (b == 125 && g++ == 0 && Qt() == 125)
            continue;
        }
        switch (A += We(b), b * g) {
          case 38:
            E = d > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            l[m++] = (K(A) - 1) * E, E = 1;
            break;
          case 64:
            H() === 45 && (A += Me(q())), R = H(), d = y = K(k = A += nn(Fe())), b++;
            break;
          case 45:
            N === 45 && K(A) == 2 && (g = 0);
        }
    }
  return i;
}
function kr(e, r, t, a, o, i, u, l, p, m, d) {
  for (var y = o - 1, R = o === 0 ? i : [""], C = hr(R), N = 0, g = 0, F = 0; N < a; ++N)
    for (var E = 0, b = xe(e, y + 1, y = Gt(g = u[N])), k = e; E < C; ++E)
      (k = Qr(g > 0 ? R[E] + " " + b : O(b, /&\f/g, R[E]))) && (p[F++] = k);
  return Ue(e, r, t, o === 0 ? dr : l, p, m, d);
}
function on(e, r, t) {
  return Ue(e, r, t, lr, We(Xt()), xe(e, 2, -2), 0);
}
function Ir(e, r, t, a) {
  return Ue(e, r, t, pr, xe(e, 0, a), xe(e, a + 1, -1), a);
}
function ce(e, r) {
  for (var t = "", a = hr(e), o = 0; o < a; o++)
    t += r(e[o], o, e, r) || "";
  return t;
}
function sn(e, r, t, a) {
  switch (e.type) {
    case Bt:
      if (e.children.length)
        break;
    case qt:
    case pr:
      return e.return = e.return || e.value;
    case lr:
      return "";
    case Xr:
      return e.return = e.value + "{" + ce(e.children, a) + "}";
    case dr:
      e.value = e.props.join(",");
  }
  return K(t = ce(e.children, a)) ? e.return = e.value + "{" + t + "}" : "";
}
function cn(e) {
  var r = hr(e);
  return function(t, a, o, i) {
    for (var u = "", l = 0; l < r; l++)
      u += e[l](t, a, o, i) || "";
    return u;
  };
}
function fn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function un(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var ln = function(r, t, a) {
  for (var o = 0, i = 0; o = i, i = H(), o === 38 && i === 12 && (t[a] = 1), !_e(i); )
    q();
  return Ce(r, U);
}, dn = function(r, t) {
  var a = -1, o = 44;
  do
    switch (_e(o)) {
      case 0:
        o === 38 && H() === 12 && (t[a] = 1), r[a] += ln(U - 1, t, a);
        break;
      case 2:
        r[a] += Me(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = H() === 58 ? "&\f" : "", t[a] = r[a].length;
          break;
        }
      default:
        r[a] += We(o);
    }
  while (o = q());
  return r;
}, pn = function(r, t) {
  return tt(dn(rt(r), t));
}, Dr = /* @__PURE__ */ new WeakMap(), hn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !Dr.get(a)) && !o) {
      Dr.set(r, !0);
      for (var i = [], u = pn(t, i), l = a.props, p = 0, m = 0; p < u.length; p++)
        for (var d = 0; d < l.length; d++, m++)
          r.props[m] = i[p] ? u[p].replace(/&\f/g, l[d]) : l[d] + " " + u[p];
    }
  }
}, mn = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, vn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", yn = function(r) {
  return r.type === "comm" && r.children.indexOf(vn) > -1;
}, gn = function(r) {
  return function(t, a, o) {
    if (!(t.type !== "rule" || r.compat)) {
      var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var u = !!t.parent, l = u ? t.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var m = l[p];
          if (m.line < t.line)
            break;
          if (m.column < t.column) {
            if (yn(m))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, nt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, En = function(r, t) {
  for (var a = r - 1; a >= 0; a--)
    if (!nt(t[a]))
      return !0;
  return !1;
}, Fr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, bn = function(r, t, a) {
  nt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Fr(r)) : En(t, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Fr(r)));
};
function at(e, r) {
  switch (Kt(e, r)) {
    case 5103:
      return T + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return T + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return T + e + Ye + e + W + e + e;
    case 6828:
    case 4268:
      return T + e + W + e + e;
    case 6165:
      return T + e + W + "flex-" + e + e;
    case 5187:
      return T + e + O(e, /(\w+).+(:[^]+)/, T + "box-$1$2" + W + "flex-$1$2") + e;
    case 5443:
      return T + e + W + "flex-item-" + O(e, /flex-|-self/, "") + e;
    case 4675:
      return T + e + W + "flex-line-pack" + O(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return T + e + W + O(e, "shrink", "negative") + e;
    case 5292:
      return T + e + W + O(e, "basis", "preferred-size") + e;
    case 6060:
      return T + "box-" + O(e, "-grow", "") + T + e + W + O(e, "grow", "positive") + e;
    case 4554:
      return T + O(e, /([^-])(transform)/g, "$1" + T + "$2") + e;
    case 6187:
      return O(O(O(e, /(zoom-|grab)/, T + "$1"), /(image-set)/, T + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return O(e, /(image-set\([^]*)/, T + "$1$`$1");
    case 4968:
      return O(O(e, /(.+:)(flex-)?(.*)/, T + "box-pack:$3" + W + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + T + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return O(e, /(.+)-inline(.+)/, T + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (V(e, r + 1)) {
          case 109:
            if (V(e, r + 4) !== 45)
              break;
          case 102:
            return O(e, /(.+:)(.+)-([^]+)/, "$1" + T + "$2-$3$1" + Ye + (V(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~or(e, "stretch") ? at(O(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (V(e, r + 1) !== 115)
        break;
    case 6444:
      switch (V(e, K(e) - 3 - (~or(e, "!important") && 10))) {
        case 107:
          return O(e, ":", ":" + T) + e;
        case 101:
          return O(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + T + (V(e, 14) === 45 ? "inline-" : "") + "box$3$1" + T + "$2$3$1" + W + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (V(e, r + 11)) {
        case 114:
          return T + e + W + O(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return T + e + W + O(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return T + e + W + O(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return T + e + W + e + e;
  }
  return e;
}
var xn = function(r, t, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case pr:
        r.return = at(r.value, r.length);
        break;
      case Xr:
        return ce([be(r, {
          value: O(r.value, "@", "@" + T)
        })], o);
      case dr:
        if (r.length)
          return Zt(r.props, function(i) {
            switch (Ht(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ce([be(r, {
                  props: [O(i, /:(read-\w+)/, ":" + Ye + "$1")]
                })], o);
              case "::placeholder":
                return ce([be(r, {
                  props: [O(i, /:(plac\w+)/, ":" + T + "input-$1")]
                }), be(r, {
                  props: [O(i, /:(plac\w+)/, ":" + Ye + "$1")]
                }), be(r, {
                  props: [O(i, /:(plac\w+)/, W + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, _n = [xn], Sn = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var F = g.getAttribute("data-emotion");
      F.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || _n;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i = {}, u, l = [];
  u = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(g) {
      for (var F = g.getAttribute("data-emotion").split(" "), E = 1; E < F.length; E++)
        i[F[E]] = !0;
      l.push(g);
    }
  );
  var p, m = [hn, mn];
  process.env.NODE_ENV !== "production" && m.push(gn({
    get compat() {
      return N.compat;
    }
  }), bn);
  {
    var d, y = [sn, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== lr && d.insert(g.value + "{}"));
    } : fn(function(g) {
      d.insert(g);
    })], R = cn(m.concat(o, y)), C = function(F) {
      return ce(an(F), R);
    };
    p = function(F, E, b, k) {
      d = b, process.env.NODE_ENV !== "production" && E.map !== void 0 && (d = {
        insert: function(c) {
          b.insert(c + E.map);
        }
      }), C(F ? F + "{" + E.styles + "}" : E.styles), k && (N.inserted[E.name] = !0);
    };
  }
  var N = {
    key: t,
    sheet: new Ut({
      key: t,
      container: u,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return N.sheet.hydrate(l), N;
}, sr = { exports: {} }, P = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function Cn() {
  if (Mr)
    return P;
  Mr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function k(c) {
    if (typeof c == "object" && c !== null) {
      var Y = c.$$typeof;
      switch (Y) {
        case r:
          switch (c = c.type, c) {
            case p:
            case m:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case N:
                case C:
                case u:
                  return c;
                default:
                  return Y;
              }
          }
        case t:
          return Y;
      }
    }
  }
  function D(c) {
    return k(c) === m;
  }
  return P.AsyncMode = p, P.ConcurrentMode = m, P.ContextConsumer = l, P.ContextProvider = u, P.Element = r, P.ForwardRef = d, P.Fragment = a, P.Lazy = N, P.Memo = C, P.Portal = t, P.Profiler = i, P.StrictMode = o, P.Suspense = y, P.isAsyncMode = function(c) {
    return D(c) || k(c) === p;
  }, P.isConcurrentMode = D, P.isContextConsumer = function(c) {
    return k(c) === l;
  }, P.isContextProvider = function(c) {
    return k(c) === u;
  }, P.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, P.isForwardRef = function(c) {
    return k(c) === d;
  }, P.isFragment = function(c) {
    return k(c) === a;
  }, P.isLazy = function(c) {
    return k(c) === N;
  }, P.isMemo = function(c) {
    return k(c) === C;
  }, P.isPortal = function(c) {
    return k(c) === t;
  }, P.isProfiler = function(c) {
    return k(c) === i;
  }, P.isStrictMode = function(c) {
    return k(c) === o;
  }, P.isSuspense = function(c) {
    return k(c) === y;
  }, P.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === m || c === i || c === o || c === y || c === R || typeof c == "object" && c !== null && (c.$$typeof === N || c.$$typeof === C || c.$$typeof === u || c.$$typeof === l || c.$$typeof === d || c.$$typeof === F || c.$$typeof === E || c.$$typeof === b || c.$$typeof === g);
  }, P.typeOf = k, P;
}
var $ = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function Rn() {
  return jr || (jr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function k(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === a || h === m || h === i || h === o || h === y || h === R || typeof h == "object" && h !== null && (h.$$typeof === N || h.$$typeof === C || h.$$typeof === u || h.$$typeof === l || h.$$typeof === d || h.$$typeof === F || h.$$typeof === E || h.$$typeof === b || h.$$typeof === g);
    }
    function D(h) {
      if (typeof h == "object" && h !== null) {
        var ve = h.$$typeof;
        switch (ve) {
          case r:
            var oe = h.type;
            switch (oe) {
              case p:
              case m:
              case a:
              case i:
              case o:
              case y:
                return oe;
              default:
                var te = oe && oe.$$typeof;
                switch (te) {
                  case l:
                  case d:
                  case N:
                  case C:
                  case u:
                    return te;
                  default:
                    return ve;
                }
            }
          case t:
            return ve;
        }
      }
    }
    var c = p, Y = m, A = l, Be = u, Re = r, Ge = d, Je = a, we = N, G = C, Z = t, re = i, Te = o, Oe = y, le = !1;
    function Pe(h) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(h) || D(h) === p;
    }
    function de(h) {
      return D(h) === m;
    }
    function $e(h) {
      return D(h) === l;
    }
    function Ne(h) {
      return D(h) === u;
    }
    function Ae(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function Ke(h) {
      return D(h) === d;
    }
    function He(h) {
      return D(h) === a;
    }
    function pe(h) {
      return D(h) === N;
    }
    function he(h) {
      return D(h) === C;
    }
    function ne(h) {
      return D(h) === t;
    }
    function me(h) {
      return D(h) === i;
    }
    function ae(h) {
      return D(h) === o;
    }
    function Ze(h) {
      return D(h) === y;
    }
    $.AsyncMode = c, $.ConcurrentMode = Y, $.ContextConsumer = A, $.ContextProvider = Be, $.Element = Re, $.ForwardRef = Ge, $.Fragment = Je, $.Lazy = we, $.Memo = G, $.Portal = Z, $.Profiler = re, $.StrictMode = Te, $.Suspense = Oe, $.isAsyncMode = Pe, $.isConcurrentMode = de, $.isContextConsumer = $e, $.isContextProvider = Ne, $.isElement = Ae, $.isForwardRef = Ke, $.isFragment = He, $.isLazy = pe, $.isMemo = he, $.isPortal = ne, $.isProfiler = me, $.isStrictMode = ae, $.isSuspense = Ze, $.isValidElementType = k, $.typeOf = D;
  }()), $;
}
process.env.NODE_ENV === "production" ? sr.exports = Cn() : sr.exports = Rn();
var wn = sr.exports, ot = wn, Tn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, On = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, it = {};
it[ot.ForwardRef] = Tn;
it[ot.Memo] = On;
var Pn = !0;
function $n(e, r, t) {
  var a = "";
  return t.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var st = function(r, t, a) {
  var o = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Pn === !1) && r.registered[o] === void 0 && (r.registered[o] = t.styles);
}, Nn = function(r, t, a) {
  st(r, t, a);
  var o = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = t;
    do
      r.insert(t === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function An(e) {
  for (var r = 0, t, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    t = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var kn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Lr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, In = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Dn = /[A-Z]|^ms/g, ct = /_EMO_([^_]+?)_([^]*?)_EMO_/g, mr = function(r) {
  return r.charCodeAt(1) === 45;
}, Yr = function(r) {
  return r != null && typeof r != "boolean";
}, nr = /* @__PURE__ */ un(function(e) {
  return mr(e) ? e : e.replace(Dn, "-$&").toLowerCase();
}), Ve = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(ct, function(a, o, i) {
          return J = {
            name: o,
            styles: i,
            next: J
          }, o;
        });
  }
  return kn[r] !== 1 && !mr(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var Fn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Mn = ["normal", "none", "initial", "inherit", "unset"], jn = Ve, Ln = /^-ms-/, Yn = /-(.)/g, Vr = {};
  Ve = function(r, t) {
    if (r === "content" && (typeof t != "string" || Mn.indexOf(t) === -1 && !Fn.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var a = jn(r, t);
    return a !== "" && !mr(r) && r.indexOf("-") !== -1 && Vr[r] === void 0 && (Vr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Ln, "ms-").replace(Yn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ft = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Se(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ft);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return J = {
          name: t.name,
          styles: t.styles,
          next: J
        }, t.name;
      if (t.styles !== void 0) {
        var a = t.next;
        if (a !== void 0)
          for (; a !== void 0; )
            J = {
              name: a.name,
              styles: a.styles,
              next: J
            }, a = a.next;
        var o = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (o += t.map), o;
      }
      return Vn(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = J, u = t(e);
        return J = i, Se(e, r, u);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = t.replace(ct, function(d, y, R) {
          var C = "animation" + l.length;
          return l.push("const " + C + " = keyframes`" + R.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + C + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var m = r[t];
  return m !== void 0 ? m : t;
}
function Vn(e, r, t) {
  var a = "";
  if (Array.isArray(t))
    for (var o = 0; o < t.length; o++)
      a += Se(e, r, t[o]) + ";";
  else
    for (var i in t) {
      var u = t[i];
      if (typeof u != "object")
        r != null && r[u] !== void 0 ? a += i + "{" + r[u] + "}" : Yr(u) && (a += nr(i) + ":" + Ve(i, u) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ft);
        if (Array.isArray(u) && typeof u[0] == "string" && (r == null || r[u[0]] === void 0))
          for (var l = 0; l < u.length; l++)
            Yr(u[l]) && (a += nr(i) + ":" + Ve(i, u[l]) + ";");
        else {
          var p = Se(e, r, u);
          switch (i) {
            case "animation":
            case "animationName": {
              a += nr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(In), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Wr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ut;
process.env.NODE_ENV !== "production" && (ut = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var J, zr = function(r, t, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  J = void 0;
  var u = r[0];
  u == null || u.raw === void 0 ? (o = !1, i += Se(a, t, u)) : (process.env.NODE_ENV !== "production" && u[0] === void 0 && console.error(Lr), i += u[0]);
  for (var l = 1; l < r.length; l++)
    i += Se(a, t, r[l]), o && (process.env.NODE_ENV !== "production" && u[l] === void 0 && console.error(Lr), i += u[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(ut, function(R) {
    return p = R, "";
  })), Wr.lastIndex = 0;
  for (var m = "", d; (d = Wr.exec(i)) !== null; )
    m += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = An(i) + m;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: J,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: J
  };
}, Wn = function(r) {
  return r();
}, zn = Q["useInsertionEffect"] ? Q["useInsertionEffect"] : !1, Un = zn || Wn, qe = {}.hasOwnProperty, vr = /* @__PURE__ */ Q.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Sn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (vr.displayName = "EmotionCacheContext");
vr.Provider;
var qn = function(r) {
  return /* @__PURE__ */ ur(function(t, a) {
    var o = Ft(vr);
    return r(t, o, a);
  });
}, lt = /* @__PURE__ */ Q.createContext({});
process.env.NODE_ENV !== "production" && (lt.displayName = "EmotionThemeContext");
var Ur = function(r) {
  var t = r.split(".");
  return t[t.length - 1];
}, Bn = function(r) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(r), t))
    return Ur(t[1]);
}, Gn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Jn = function(r) {
  return r.replace(/\$/g, "-");
}, Kn = function(r) {
  if (r)
    for (var t = r.split(`
`), a = 0; a < t.length; a++) {
      var o = Bn(t[a]);
      if (o) {
        if (Gn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Jn(o);
      }
    }
}, cr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", fr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", dt = function(r, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var a = {};
  for (var o in t)
    qe.call(t, o) && (a[o] = t[o]);
  if (a[cr] = r, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var i = Kn(new Error().stack);
    i && (a[fr] = i);
  }
  return a;
}, Hn = function(r) {
  var t = r.cache, a = r.serialized, o = r.isStringTag;
  return st(t, a, o), Un(function() {
    return Nn(t, a, o);
  }), null;
}, pt = /* @__PURE__ */ qn(function(e, r, t) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[cr], i = [a], u = "";
  typeof e.className == "string" ? u = $n(r.registered, i, e.className) : e.className != null && (u = e.className + " ");
  var l = zr(i, void 0, Q.useContext(lt));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[fr];
    p && (l = zr([l, "label:" + p + ";"]));
  }
  u += r.key + "-" + l.name;
  var m = {};
  for (var d in e)
    qe.call(e, d) && d !== "css" && d !== cr && (process.env.NODE_ENV === "production" || d !== fr) && (m[d] = e[d]);
  return m.ref = t, m.className = u, /* @__PURE__ */ Q.createElement(Q.Fragment, null, /* @__PURE__ */ Q.createElement(Hn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ Q.createElement(o, m));
});
process.env.NODE_ENV !== "production" && (pt.displayName = "EmotionCssPropInternal");
var ht = pt;
function ee(e, r, t) {
  return qe.call(r, "css") ? Le.jsx(ht, dt(e, r), t) : Le.jsx(e, r, t);
}
function qr(e, r, t) {
  return qe.call(r, "css") ? Le.jsxs(ht, dt(e, r), t) : Le.jsxs(e, r, t);
}
const yr = Mt(void 0);
yr.displayName = "TimelineContext";
function Zn(e, r) {
  return S`
    display: inline-flex;
    ${e === "vertical" && "flex-direction: column"};
    ${e === "horizontal" && r === "alternate" && S`
      min-height: 100px;
      align-items: center;
    `};
  `;
}
function Xn(e, r, t) {
  if (e === "horizontal") {
    let o;
    return r === "alternate-same" ? o = S`
        margin-top: 16px;
        padding-bottom: 8px;
        transform: translateY(-50%);
      ` : r === "alternate-relative" ? o = S`
        margin-top: -16px;
        padding-top: 8px;
        transform: translateY(50%);
      ` : r === "bottom" ? o = S`
        padding-bottom: 8px;
      ` : o = S`
        padding-top: 8px;
      `, S`
      ${o};
      flex: ${t ? "unset" : "1"};
      position: relative;
    `;
  }
  const a = S`
    &:last-of-type {
      padding-bottom: ${t ? "20px" : "0"};
    }
  `;
  return S`
    position: relative;
    margin: 0;
    padding-bottom: 42px;
    ${a};
  `;
}
function Qn(e, r) {
  let t = e || Jr(`--${Kr}-blue-03`), a;
  return r === "hollow" ? a = S`
      border: 1px solid ${t};
    ` : a = S`
      background-color: ${t};
    `, S`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    ${a};
  `;
}
function ea(e, r) {
  const t = S`
    position: absolute;
    text-align: center;
  `;
  return e === "horizontal" ? r === "bottom" || r === "alternate-same" ? S`
        ${t};
        width: 100%;
        bottom: 0;
      ` : S`
        ${t};
        width: 100%;
        top: 0;
      ` : r === "alternate-same" || r === "alternate-relative" ? S`
        ${t};
        height: 100%;
        left: 50%;
      ` : r === "right" ? S`
        ${t};
        height: 100%;
        right: 0;
      ` : S`
        ${t};
        height: 100%;
        left: 0;
      `;
}
function ra(e, r, t) {
  let a = t || Jr(`--${Kr}-grayBlue-08`);
  return e === "horizontal" ? S`
      box-sizing: border-box;
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      bottom: -4px;
      left: 24px;
      right: 0;
      height: 1px;
      border-top: 1px ${r} ${a};
    ` : S`
    box-sizing: border-box;
    position: absolute;
    transform: translateX(-50%);
    top: 24px;
    bottom: 0;
    left: 50%;
    width: 1px;
    border-left: 1px ${r} ${a};
  `;
}
const Br = S`
  display: flex;
  justify-content: center;
  align-items: center;
`;
function ta(e) {
  return e === "horizontal" ? S`
      ${Br};
      width: 24px;
      height: 16px;
      line-height: 6px;
      position: relative;
    ` : S`
    ${Br};
    width: 6px;
    height: 24px;
    line-height: 24px;
    position: relative;
  `;
}
function na(e) {
  return e === "alternate-same" ? S`
      left: 50%;
      width: 50%;
      margin-left: 22px;
      padding-right: 22px;
    ` : e === "alternate-relative" ? S`
      left: 0;
      margin-left: -16px;
      margin-right: 0;
      text-align: right;
      width: 50%;
      padding-right: 16px;
    ` : e === "right" ? S`
      text-align: right;
      margin-left: 0;
      margin-right: 16px;
    ` : S`
      margin-left: 16px;
    `;
}
function aa(e) {
  return e === "alternate-same" ? S`
      margin-bottom: 16px;
      margin-right: 20px;
      padding-bottom: unset;
    ` : e === "alternate-relative" ? S`
      margin-top: 16px;
      margin-right: 20px;
    ` : e === "bottom" ? S`
      margin-bottom: 16px;
      margin-right: 20px;
      padding-bottom: unset;
    ` : S`
      margin-top: 16px;
      margin-right: 20px;
    `;
}
function oa(e, r, t) {
  let a;
  return e === "horizontal" ? a = aa(r) : a = na(r), S`
    position: relative;
    padding-bottom: 2px;
    ${t && S`
      font-size: 14px;
      line-height: 22px;
    `};
    ${a};
  `;
}
const ia = (e, r, t) => {
  let a = ["alternate-same", "alternate-relative"], o = Math.abs(r % 2 - (t === "relative" ? 1 : 0));
  return e === "alternate" ? a[o] : e;
}, mt = ur((e, r) => ee(yr.Consumer, { children: (t) => {
  const a = t == null ? void 0 : t.isChildrenLast, { dot: o, direction: i = (t == null ? void 0 : t.direction) || "vertical", mode: u = (t == null ? void 0 : t.mode) || "left", index: l = (t == null ? void 0 : t.index) || 0, label: p, labelPosition: m = "same", dotColor: d, dotType: y = "solid", lineType: R = "solid", lineColor: C, autoFixDotSize: N = !0, children: g, ...F } = e, E = ia(u, l, m);
  return qr("div", { css: [
    Xn(i, E, o),
    Hr(e)
  ], ref: r, ...Zr(F), children: [qr("div", { css: ea(i, E), children: [a ? null : ee("div", { css: ra(i, R, C) }), ee("div", { css: ta(i), children: o || ee("div", { css: Qn(d, y) }) })] }), ee("div", { css: oa(i, E, N), children: p || g })] });
} }));
mt.displayName = "TimelineItem";
const sa = ur((e, r) => {
  const { reverse: t, mode: a = "left", direction: o = "vertical", pending: i, pendingDot: u = ee(Lt, { size: "small" }), children: l, ...p } = e, m = jt.toArray(l) || [];
  t && m.reverse();
  const y = i ? ee(mt, { dot: u || (typeof i == "boolean" ? null : i), mode: a, direction: o }, m.length) : null;
  return i && m.push(y), ee("div", { ref: r, css: S(Zn(o, a), Hr(e)), ...Zr(p), children: m.map((R, C) => R ? ee(yr.Provider, { value: {
    direction: o,
    mode: a,
    index: C,
    isChildrenLast: m.length - 1 === C
  }, children: R }, C) : null) });
});
sa.displayName = "Timeline";
export {
  sa as Timeline,
  mt as TimelineItem
};
//# sourceMappingURL=index.js.map
